import { makeAutoObservable } from 'mobx'
import { type PageLayoutStore } from 'shared/layout'

export class SurveysPageStore {
  constructor(readonly pageLayoutStore: PageLayoutStore) {
    makeAutoObservable(this)
  }
}
